import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { productosEntretenimiento } from '../../data/productos';

const ProductosEntretenimiento = () => {
  const [showMore, setShowMore] = useState(false);
  const [isHiding, setIsHiding] = useState(false);
  
  // Función para manejar el toggle y scroll
  const handleToggleMore = () => {
    if (showMore) {
      // Si estamos mostrando más y vamos a ocultar, iniciar scroll primero
      document.getElementById('entretenimiento').scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
      
      // Iniciar animación de desvanecimiento después de un pequeño delay
      setTimeout(() => {
        setIsHiding(true);
      }, 200);
      
      // Ocultar productos después de que termine la animación
      setTimeout(() => {
        setShowMore(false);
        setIsHiding(false);
      }, 1000); // 200ms delay + 800ms animación
    } else {
      // Si vamos a mostrar más, solo cambiar el estado
      setShowMore(true);
    }
  };
  
  // Convertir el objeto a array
  const productosArray = Object.entries(productosEntretenimiento);
  
  const productosIniciales = productosArray.slice(0, 3);
  const productosAdicionales = productosArray.slice(3);

  return (
    <section className="products-section entretenimiento-section" id="entretenimiento">
      <div className="section-container">
        <h2 className="section-title">Entretenimiento</h2>
        <p className="section-subtitle">Muebles para tu área de entretenimiento y living</p>
        {/* Productos iniciales (siempre visibles) */}
        <div className="products-grid">
          {productosIniciales.map(([productId, product]) => (
            <Link key={productId} to={`/producto/${productId}`} className="product-placeholder">
              <div 
                className="placeholder-image" 
                style={{backgroundImage: `url(${product.images[0]})`}}
              ></div>
              <div className="placeholder-content">
                <h3>{product.name}</h3>
                <p>{product.price}</p>
              </div>
            </Link>
          ))}
        </div>
        
        {/* Productos adicionales (condicionales) */}
        {showMore && (
          <div className={`additional-products ${isHiding ? 'hiding' : ''}`}>
            {productosAdicionales.map(([productId, product]) => (
              <Link key={productId} to={`/producto/${productId}`} className="product-placeholder">
                <div 
                  className="placeholder-image" 
                  style={{backgroundImage: `url(${product.images[0]})`}}
                ></div>
                <div className="placeholder-content">
                  <h3>{product.name}</h3>
                  <p>{product.price}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
        
        {/* Botón Ver más/Ver menos */}
        {productosAdicionales.length > 0 && (
          <div className="show-more-container">
            <button 
              className="show-more-button"
              onClick={handleToggleMore}
            >
              {showMore ? 'Ver menos' : 'Ver más'}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductosEntretenimiento;
